import { EnergyType } from "../types/energyType"
import { type SelectedEnergyTypes } from "../types/selectedEnergyTypes"

export function hasElectricity(selectedEnergyTypes: SelectedEnergyTypes) {
    return selectedEnergyTypes.includes(EnergyType.Electricity)
}

export function hasGas(selectedEnergyTypes: SelectedEnergyTypes) {
    return selectedEnergyTypes.includes(EnergyType.Gas)
}
